export function filterAndSortProjects(savedViews) {
    return savedViews
        .filter((savedView) => savedView.status !== false)
        .sort((a, b) => a.name.localeCompare(b.name))
        .sort((a, b) => (a.description || '').localeCompare(b.description || ''));
}
export function groupSavedDataByList(savedViews) {
    const filteredAndSorted = filterAndSortProjects(savedViews);
    return Object.entries(filteredAndSorted.reduce((groups, savedView) => {
        const description = savedView.description || 'Default';
        groups[description] = groups[description] || [];
        groups[description].push(savedView);
        return groups;
    }, {}))
        .map(([listName, savedViewList]) => ({
        listName,
        savedViews: savedViewList
    }))
        .sort((a, b) => a.listName.localeCompare(b.listName));
}
